import script from "./VPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VPage.vue?vue&type=script&setup=true&lang=ts"

import "./VPage.vue?vue&type=style&index=0&id=c4309aa0&lang=scss"

const __exports__ = script;

export default __exports__